export const createEventUrl = "/event/createEvent";
export const updateEventUrl = "/event/updateEvent";
export const deleteEventUrl = "/event/deleteEvent";
export const checkInGuestUrl = "/event/checkInGuest";
export const getAllGuestsUrl = "/event/getAllGuests";
export const exportAllGuestsExcelUrl = "/event/exportAllGuestsExcel";
export const getActualEventUrl = "/event/getActualEvent";


